import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Hero3 from '../../components/hero3/hero3'
import CaseStudyHero from '../../components/hero3/casestudyhero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import casestudy from '../../images/casestudy.png'
import { Link } from 'react-router-dom'

const Guides = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <CaseStudyHero top_title={<>Your Shortcut to, <br/> Everything</>} top_desp={<>A collection of powerful productivity tools all within an <br/> extendable launcher. Fast, ergonomic and reliable.</>} />

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <ul className='guide_list'>
                                        <li><img src={casestudy} alt='casestudy' /></li>
                                        <li>
                                            <h3>Lorem Ipsum is simply dummy text of the</h3>
                                            <button className='download_btn'>Download Now</button>
                                        </li>
                                    </ul>
                                </div>

                                <div className='col-lg-6'>
                                    <ul className='guide_list'>
                                        <li><img src={casestudy} alt='casestudy' /></li>
                                        <li>
                                            <h3>Lorem Ipsum is simply dummy text of the</h3>
                                            <button className='download_btn'>Download Now</button>
                                        </li>
                                    </ul>
                                </div>

                                <div className='col-lg-6'>
                                    <ul className='guide_list'>
                                        <li><img src={casestudy} alt='casestudy' /></li>
                                        <li>
                                            <h3>Lorem Ipsum is simply dummy text of the</h3>
                                            <button className='download_btn'>Download Now</button>
                                        </li>
                                    </ul>
                                </div>

                                <div className='col-lg-6'>
                                    <ul className='guide_list'>
                                        <li><img src={casestudy} alt='casestudy' /></li>
                                        <li>
                                            <h3>Lorem Ipsum is simply dummy text of the</h3>
                                            <button className='download_btn'>Download Now</button>
                                        </li>
                                    </ul>
                                </div>


                            </div>
                        </div>
                    </section>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default Guides;
